import styled from 'styled-components'
import {SPACING} from '../constants'

const FreeWidthTaker = styled.div`
  margin-right: ${SPACING / 2}px;
  flex-grow: 1;
`

export default FreeWidthTaker
